import { Stack, Typography, Button, useTheme } from "@mui/material";
import { useState } from "react";
import { RadioButtons } from "components/Inputs/RadioButtons/RadioButtons";
import HelpModal from "components/DataDisplay/HelpModal/HelpModal";
import { useHistory } from "react-router-dom";

export default function ConfirmStove({ service, onChangePage }) {
    const theme = useTheme();
    const [hasStove, setHasStove] = useState(null);
    const [unavailableService, setUnavailableService] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const router = useHistory();

    return (
        <>
            {unavailableService ? (
                <Stack p={"0px 32px 32px 32px"}>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        border="1px solid #2CABF9"
                        p="16px"
                        borderRadius="16px"
                        mt={"32px"}
                    >
                        <Stack width="100%">
                            <Typography
                                fontSize={"25px"}
                                fontWeight={700}
                                mb={"18px"}
                                sx={{
                                    color: theme.palette.primary.main,
                                }}
                            >
                                O serviço não poderá ser realizado
                            </Typography>

                            <Typography
                                fontSize={"14px"}
                                fontWeight={500}
                                color="#636363"
                                align="justify"
                                lineHeight={"100%"}
                            >
                                Assim que o fogão estiver posicionado no local
                                de instalação, contrate o serviço novamente.
                                Caso precise de mais informações, clique no
                                botão abaixo para falar com nossa central de
                                atendimento.
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>
            ) : (
                <Stack p={"0px 32px 32px 32px"}>
                    <Typography fontSize={"25px"} fontWeight={700} mb={"18px"}>
                        Instalação completa
                    </Typography>

                    <Typography
                        fontSize={"14px"}
                        fontWeight={500}
                        color="#636363"
                        align="justify"
                        lineHeight={"100%"}
                    >
                        Para efetuar instalação completa, precisamos saber se o
                        seu fogão já está no local e posicionado onde será
                        instalado, pois se não estiver, o serviço não poderá ser
                        realizado.
                    </Typography>

                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        border="1px solid #2CABF9"
                        p="16px"
                        borderRadius="16px"
                        mt={"60px"}
                    >
                        <Stack width="100%">
                            <Typography
                                fontSize="18px"
                                fontWeight={600}
                                color="#053462"
                                mb={"13px"}
                            >
                                O fogão já está no local e posicionando onde
                                será instalado?
                            </Typography>
                            <RadioButtons
                                value={hasStove}
                                onChange={setHasStove}
                                options={[
                                    { value: "YES", label: "Sim" },
                                    { value: "NO", label: "Não" },
                                ]}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            )}

            <Stack
                height={unavailableService ? "auto" : "135px"}
                bgcolor={"#053462"}
            >
                {unavailableService ? (
                    <Stack alignItems={"center"} gap={"20px"} my={"33px"}>
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={{
                                color: "#fff",
                                height: "45px",
                                width: "358px",
                                borderRadius: "36px",
                            }}
                            disabled={hasStove === null}
                            onClick={() => {
                                return router.push("/save-time");
                            }}
                        >
                            INSTALAR DEPOIS
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            sx={{
                                color: "#fff",
                                height: "45px",
                                width: "358px",
                                borderRadius: "36px",
                            }}
                            disabled={hasStove === null}
                            onClick={() => {
                                setIsOpen(true);
                            }}
                        >
                            PRECISO DE ATENDIMENTO
                        </Button>
                    </Stack>
                ) : (
                    <Stack alignItems={"center"}>
                        <Stack
                            alignSelf={"flex-start"}
                            mt={"25px"}
                            mb={"20px"}
                            width={"100%"}
                            justifyContent={"center"}
                            alignItems={"center"}
                        >
                            <button
                                className="inline-link"
                                onClick={() =>
                                    window.open("/warranty-terms", "_blank")
                                }
                            >
                                Termos de garantia
                            </button>
                        </Stack>
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={{
                                color: "#fff",
                                height: "45px",
                                width: "358px",
                                borderRadius: "36px",
                            }}
                            disabled={hasStove === null}
                            onClick={() => {
                                if (hasStove === "YES") {
                                    onChangePage("confirmService", service);
                                } else {
                                    setUnavailableService(true);
                                }
                            }}
                        >
                            CONTRATAR
                        </Button>
                    </Stack>
                )}
            </Stack>

            <HelpModal open={isOpen} onClose={() => setIsOpen(false)} />
        </>
    );
}
